import classNames from 'classnames'
import { JSX } from 'react'

import {
  IInputCommonProps,
  IInputProps,
  Input,
  INumberProps,
  NumberInput,
} from 'core-components/library/inputs'
import { IValidateInputProps, ValidateInput } from 'core-components/library/validation'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn<TProps> = (props: TProps) => JSX.Element | null

const getDisabledTheme = (disabled?: boolean) => (disabled ? themesStyles.disabledInput : undefined)

const applyDisabled = <TProps extends IInputCommonProps>(component: TComponentFn<TProps>) => {
  return (props: TProps) => {
    const { disabled, classes } = props
    const disabledTheme = getDisabledTheme(disabled)

    return component({
      ...props,
      classes: { ...classes, root: classNames(classes?.root, disabledTheme) },
    })
  }
}

const applyDisabledValidate = <TProps extends IValidateInputProps>(
  component: TComponentFn<TProps>
) => {
  return (props: TProps) => {
    const { disabled, classes } = props
    const disabledTheme = getDisabledTheme(disabled)

    return component({
      ...props,
      classes: {
        ...classes,
        inputClasses: {
          ...classes?.inputClasses,
          root: classNames(classes?.inputClasses?.root, disabledTheme),
        },
      },
    })
  }
}

export const OnboardingInput = (props: IInputProps) =>
  applyDisabled(createComponentFn(Input))(props)

export const OnboardingValidateInput = (props: IValidateInputProps) =>
  applyDisabledValidate(createComponentFn(ValidateInput))(props)

export const OnboardingNumberInput = (props: INumberProps) =>
  applyDisabled(createComponentFn(NumberInput))(props)
